/**
 * Decimal configuration types.
 * Used to determine which decimal configuration to apply.
 */
export const DECIMAL_TYPES = {
    /** For currency values not related to products (totals, sums, taxes) */
    CURRENCY_GENERAL: 'currencyGeneral',
    /** For product prices, line prices, discounts in value */
    CURRENCY_PRICES: 'currencyPrices',
    /** For product quantities and stock */
    QUANTITY: 'quantity',
    /** For other decimal fields (percentages, conversion factors, custom decimals) */
    GENERAL: 'general',
};

/**
 * Field names in tblSucursales (environment config) for each decimal type.
 */
export const ENVIRONMENT_DECIMAL_FIELDS = {
    [DECIMAL_TYPES.CURRENCY_GENERAL]: 'intdecimalscurrencygeneral',
    [DECIMAL_TYPES.CURRENCY_PRICES]: 'intdecimalscurrencyprices',
    [DECIMAL_TYPES.QUANTITY]: 'intdecimalsquantity',
    [DECIMAL_TYPES.GENERAL]: 'intdecimalsgeneral',
};

/**
 * Default decimals when no configuration is found.
 * For currency types, the fallback is typically ISO 4217 from tblCurrency.
 */
export const DEFAULT_DECIMALS = {
    [DECIMAL_TYPES.CURRENCY_GENERAL]: 2,
    [DECIMAL_TYPES.CURRENCY_PRICES]: 2,
    [DECIMAL_TYPES.QUANTITY]: 2,
    [DECIMAL_TYPES.GENERAL]: 2,
};
/**
 * Currency types that should use ISO 4217 as fallback.
 */
export const CURRENCY_TYPES = [DECIMAL_TYPES.CURRENCY_GENERAL, DECIMAL_TYPES.CURRENCY_PRICES];
